import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, FormHelperText, Autocomplete, Typography, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { ReadyMadestk } from '../TitleList';
import styled, { inputNumbersmall, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { createReadyMStkEntry } from '../../Store/PHPSlice/UploadStk/ReadyMadeStk';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { selectCloths, selectItems, selectRack } from '../Selectors/Master/ItemSelectors';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../NavigationContext';
import { errorStyles } from '../../Utils/table';
import Dropdown from '../FieldsComponents/Dropdown';


const ReadyMStkEntry = (props) => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        barcode: '',
        itemId: '',
        clothId: '',
        itemNm: '',
        clothNm: '',
        model: '',
        color: '',
        shadeNo: '',
        qty: '',
        size: '',
        rate: '',
        rack: '',
        userId: '1'
    });
    const [errors, setErrors] = useState({});
    const [number, setNumber] = useState('');
    const [numbers, setNumbers] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const { setPreviousPath } = useNavigation();
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    const clothlist = useSelector(selectCloths);
    const rackList = useSelector(selectRack);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchClothData());
        dispatch(fetchRackData());
    }, [dispatch]);



    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        let newFormData = { ...formData, [dropdownType]: value };

        if (dropdownType === 'itemId') {
            const selectItem = itemList.data.length > 0 ? itemList.data.find((val) => val.ID === value) : '';
            if (selectItem) {
                newFormData.itemNm = selectItem.itemNm;
            }
        } else if (dropdownType === 'clothId') {
            const selectCloth = clothlist.data.length > 0 ? clothlist.data.find((val) => val.ID === value) : '';
            if (selectCloth) {
                newFormData.clothNm = selectCloth.clothNm;
                newFormData.model = selectCloth.model;
                newFormData.color = selectCloth.color;
                newFormData.shadeNo = selectCloth.shadeNo;
            }
        }

        setFormData(newFormData);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const handleAddNumber = () => {
        if (number !== '') {
            const rangePattern = /^(\d+)-(\d+)$/;
            const match = number.match(rangePattern);

            const rangePattern2 = /^(\d+)-/;
            const match2 = number.match(rangePattern2);
            if (match) {
                const start = parseInt(match[1], 10);
                const end = parseInt(match[2], 10);

                if (start <= end) {
                    // Create an array of numbers from start to end with a difference of 2
                    const rangeArray = [...tableData];
                    // Generate numbers from start to end
                    for (let i = start; i <= end; i++) {
                        if (i <= 20 || i % 2 === 0) {
                            // rangeArray.push(i);
                            rangeArray.push({
                                size: i,
                                qty: '',
                                rate: '',
                            });
                        }
                    }

                    // Ensure the end number is included if odd
                    if (end > 20 && end % 2 !== 0 && !rangeArray.includes(end)) {
                        // rangeArray.push(end);
                        rangeArray.push({
                            size: end,
                            qty: '',
                            rate: '',
                        });
                    }

                    // Add the generated range to the numbers list
                    // setNumbers([...numbers, ...rangeArray]);

                    setTableData(rangeArray);
                }
            }
            else if (match2) {
                alert(`Complete the Sizes Value ${number}`);
            } else {
                // If the input doesn't match the range format, add the string directly to the numbers list
                // setNumbers([...numbers, number]);
                const update = {
                    size: number,
                    qty: '',
                    rate: '',
                };
                setTableData([...tableData, update]);
            }
            setNumber('');  // Clear the input field after processing
        }
    };

    // console.log(tableData)


    const handleSelectRow = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.includes(index)) {
                return prevSelectedRows.filter(rowIndex => rowIndex !== index);
            } else {
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleChange = (index, field, value) => {
        // Create a copy of the tableData to avoid direct mutation
        const updatedData = [...tableData];
        // Update the specific field for the item at the given index
        updatedData[index] = {
            ...updatedData[index],
            [field]: value, // Dynamically update the field
        };

        // Set the updated tableData
        setTableData(updatedData);
    };

    const handleDeleteSelected = () => {
        const filteredNumbers = tableData.filter((_, index) => !selectedRows.includes(index));
        setTableData(filteredNumbers);
        setSelectedRows([]); // Clear selection after delete
    };

    const validateInput = (value) => {
        // Regular expression for validating simple numbers (e.g., 22, 45)
        const validNumberPattern = /^\d+$/;

        // Regular expression for validating the allowed range formats (e.g., 20-30, 20/30, 20X30, or 20x30)
        const validRangePattern = /^\d+[-/Xx]\d+$/;

        // Check if the input is a valid number or a valid range format
        if (!validNumberPattern.test(value) && !validRangePattern.test(value)) {
            setErrors({ sizes: 'Invalid input format. Please use the format like 20-30, 20/30, 20X30, or just a number like 22.' });
            return false;
        }

        setErrors({ sizes: '' });  // Clear any errors if input is valid
        return true;
    };

    const handleChange2 = (e) => {
        const value = e.target.value;

        // Allow only numbers and valid characters (hyphen, slash, X, x)
        const restrictedPattern = /^[0-9]+[-/Xx]?[0-9]*$/;  // This pattern allows numbers with optional valid separator

        // Check if the value matches the allowed restricted pattern or is an empty string
        if (restrictedPattern.test(value) || value === '') {
            setNumber(value);
            // Validate input on each change
            validateInput(value);
        }
    };

    const handleNavitoItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // setPreviousPath(window.location.pathname);
        // navigate('/NewItemEntry');
    };

    const handleNavitoCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // setPreviousPath(window.location.pathname);
        // navigate('/NewClothEntry');
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.itemId) newErrors.itemId = 'Item is required';
        if (!formData.clothId) newErrors.clothId = 'Cloth is required';
        if (!formData.rack) newErrors.rack = 'Rack is required';
        return newErrors;
    };

    function object(tableData, formData) {

        const data = {
            dt: formData.dt,
            itemNm: formData.itemNm,
            itemId: formData.itemId,
            clothNm: formData.clothNm,
            clothId: formData.clothId,
            model: formData.model,
            color: formData.color,
            shadeNo: formData.shadeNo,
            rack: formData.rack,
            tableData: tableData,
            userId: formData.userId
        };
        return data;
    };

    const dropdownConfig = [
        {
            label: "Item",
            id: "itemId",
            options: itemList.data,
            value: formData.itemId,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || "",
            error: errors.itemId,
            helperText: errors.itemId,
            showNewButton: true,
            handleNewButton: handleNavitoItem,
        },
        {
            label: "Cloth",
            id: "clothId",
            options: clothlist.data,
            value: formData.clothId,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`,
            error: errors.clothId,
            helperText: errors.clothId,
            showNewButton: true,
            handleNewButton: handleNavitoCloth,
        },
        {
            label: "Rack",
            id: "rack",
            options: rackList.data,
            value: formData.rack,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'rack', value: newValue ? newValue.rackNm : '' } }, 'rack'),
            getOptionLabel: (option) => option.rackNm || "",
            error: errors.rack,
            helperText: errors.rack,
            showNewButton: false,
            handleNewButton: null,
        },
    ];


    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const postData = object(tableData, formData);
        // console.log(postData)
        dispatch(createReadyMStkEntry(postData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Stock Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={props?.data?.menu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>{props?.data?.title}</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: true }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="itemId">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="itemId"
                                                    name="itemId"
                                                    options={itemList.data}
                                                    getOptionLabel={(option) => option.itemNm || ""}
                                                    value={itemList.data.find(item => item.ID === formData.itemId) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            error={!!errors.itemId}
                                                            helperText={errors.itemId}
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoItem} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="clothId">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="clothId"
                                                    name="clothId"
                                                    options={clothlist.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist.data.find(item => item.ID === formData.clothId) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.clothId}
                                                            helperText={errors.clothId}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="rack">Rack:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="rack"
                                                    name="rack"
                                                    options={rackList.data}
                                                    getOptionLabel={(option) => option.rackNm || ""}
                                                    value={rackList.data.find(item => item.rackNm === formData.rack) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'rack', value: newValue ? newValue.rackNm : '' } }, 'rack')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.rack}
                                                            helperText={errors.rack}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* {dropdownConfig && dropdownConfig.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        getOptionLabel={drop.getOptionLabel}
                                        isDesktop={isDesktop}
                                        showNewButton={drop.showNewButton}
                                        handleNewButtonClick={drop.handleNewButton}
                                    />
                                ))} */}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='number'>Sizes:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    type='text'
                                                    id='number'
                                                    name='number'
                                                    value={number}
                                                    onChange={handleChange2}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button variant="contained" color="primary" onClick={handleAddNumber} size='small' disabled={number == ""}>Add</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Typography
                                        variant="body1" // or any other variant you prefer
                                        color="error" // This uses the default error color which is red in MUI
                                        sx={{
                                            color: 'red', // Directly set the color if you want a specific shade
                                            fontWeight: 'bold', // Optional: Make the text bold
                                        }}
                                    >
                                        If Range for Example: 20-30 <br />
                                        If Enter Size with Width then use ' / ' or ' X | x '
                                    </Typography>
                                </Grid>


                                <Grid item xs={12} md={12}>
                                    <Button
                                        onClick={handleDeleteSelected}
                                        disabled={selectedRows.length === 0}
                                        variant="contained"
                                        color="error"
                                    >
                                        Delete
                                    </Button>

                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TableContainer style={{
                                        width: isDesktop ? '80%' : '100%',
                                        marginLeft: isDesktop ? '20%' : '0%',
                                        overflowX: 'hidden'
                                    }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SrNo</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Array.isArray(tableData) && tableData.map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <Checkbox
                                                                checked={selectedRows.includes(index)}
                                                                onChange={() => handleSelectRow(index)}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                type="text"
                                                                value={item.size}
                                                                onChange={(e) => handleChange(index, 'size', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                type="text"
                                                                value={item.qty}
                                                                onChange={(e) => handleChange(index, 'qty', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                type="text"
                                                                value={item.rate}
                                                                onChange={(e) => handleChange(index, 'rate', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ReadyMStkEntry;
